import { useState } from "react";
import { InputForm } from "../atoms/input";
import { ChatBox } from "./chatbox";
import { VerticalLayout } from "./layout";
import { PackageComp } from "./packageComp";
import { TopNavSetting } from "./topNavigationSettings";
import { Search } from "../atoms/search";

export function CommunicationSideBar({chats, openChat, activeChat, settingId, setSettingId, searchValue, onSearchChange}) {

    function handleFilterChange(settingID) {
        setSettingId(settingID);
    }
    const getEmptyMessage = () => {
        if (settingId === 2) return "Je hebt geen ongelezen gesprekken.";
        if (settingId === 3) return "Je hebt geen gearchiveerde gesprekken.";
        return "Je hebt momenteel geen gesprekken.";
    };
    console.log("head", chats)
    return (
        <VerticalLayout className="side-bar-communication" style={{width:"30%"}}>
            <Search value={searchValue} onChange={onSearchChange} className={"communication-search"}/>
            <TopNavSetting onClick={handleFilterChange} active={settingId} settings={[{"Setting":"All", "SettingID":1},{"Setting":"Ongelezen", "SettingID":2},{"Setting":"Gearchiveerd", "SettingID":3}]}/>
             {chats.length === 0 ? (
                <div style={{ padding: "1rem", color: "var(--text-color-secondary)" }}>
                      {getEmptyMessage()}
                </div>
            ) : (
                chats.map((chat, index) => (
                    <ChatBox
                        key={chat.id_chat}
                        activeChat={activeChat === index}
                        onClick={() => openChat(index, chat.id_course)}
                        chatData={chat}
                    />
                ))
            )}
        </VerticalLayout>
    )
}